import React from 'react';
import styled, { css, keyframes } from 'styled-components';

interface SkeletonLoadingProps {
  width: number;
  height: number;
  circle?: boolean;
}

const LoadingAnimation = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  `;

export const Loading = css`
  background: var(--decorative-subdued);
  background-clip: content-box; // Don't skeleton load the padding
  animation: ${LoadingAnimation} 1.5s ease-in-out infinite;
  color: transparent;
  cursor: progress;
`;

const Container = styled.div<{ height: number; width: number; circle?: boolean }>`
  ${Loading}
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  ${({ circle }) => circle && `border-radius: 50%;`}
`;

const SkeletonLoading = ({ width, height, circle }: SkeletonLoadingProps) => (
  <Container width={width} height={height} circle={circle} />
);

export default SkeletonLoading;
